<!--  -->
<template>
  <div class="people-count">
    <div id="personCountChart" style="height: 100%; width: 98%"></div>
  </div>
</template>

<script>
import charts from "echarts";
import API from "../api/index";
export default {
  data() {
    return {
      personCountChart: null,
      personCountChartOption: {},
      xData: [],
      yData: [[]],
    };
  },

  mounted() {
    var self = this;

    self.personCountChart = charts.init(
      document.getElementById("personCountChart")
    );
    self.queryData().then((res) => {
      self.initTrafficChartOption();
    });
  },

  methods: {
    queryData() {
      return new Promise((resolve, reject) => {
        this.$fetch(API.statPersonnelInParkByHours).then((res) => {
          if (res.success) {
            res.returnObj.forEach((el) => {
              this.xData.push(el.hours);
              this.yData[0].push(el.personnelCount);
              // this.yData[1].push(el.personnelOutCount);
            });
            resolve({ xData: this.xData, yData: this.yData });
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    initTrafficChartOption() {
      // let xData = ["09", "10", "11", "12", "13", "14", "15", "16", "17"];
      let lenData = ["人数"];
      let data1 = [[220, 182, 191, 210, 230, 270, 270, 201, 154]];
      let color = ["#00ca95"];

      const hexToRgba = (hex, opacity) => {
        let rgbaColor = "";
        let reg = /^#[\da-f]{6}$/i;
        if (reg.test(hex)) {
          rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
            "0x" + hex.slice(3, 5)
          )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
        }
        return rgbaColor;
      };
      //数据处理
      let datas = [];
      lenData.map((item, index) => {
        datas.push({
          name: item,
          type: "line",
          smooth: false,
          symbol: "none",
          symbolSize: 4,
          zlevel: 3,
          itemStyle: {
            color: hexToRgba(color[index], 0.4),
            borderColor: hexToRgba(color[index], 0.4),
            borderWidth: 5,
          },
          areaStyle: {
            normal: {
              color: new charts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: hexToRgba(color[index], 0.4),
                  },
                  {
                    offset: 1,
                    color: hexToRgba(color[index], 0.1),
                  },
                ],
                false
              ),
              shadowColor: hexToRgba(color[index], 0.1),
              shadowBlur: 10,
            },
          },
          data: this.yData[index],
        });
      });
      this.personCountChartOption = {
        grid: {
          bottom: 10,
          containLabel: true,
          left: 25,
          right: 30,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          top: 10,
          right: 10,
          data: lenData,
          textStyle: {
            color: "#ffffff",
          },
          itemGap: 10,
          itemWidth: 20,
          itemHeight: 12,
        },
        yAxis: [
          {
            type: "value",
            name: "单位：人",
            axisLabel: {
              show: true,
              width: "100",
              height: 12,
              fontSize: 14,
              fontFamily: "Source Han Sans SC",
              fontWeight: 400,
              color: "#ffffff",
            },
            nameTextStyle: {
              color: "#ffffff",
              align: "left",
              padding: [0, 0, 0, 0],
              lineHeight: 40,
              height: 12,
              fontSize: 12,
              fontFamily: "Source Han Sans SC",
              fontWeight: 400,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgb(10, 59, 119)",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#1E2537",
                type: "solid",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        xAxis: [
          {
            name: "时",
            data: this.xData,
            type: "category",
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#ffffff",
              height: 13,
              fontSize: 14,
              fontFamily: "Source Han Sans SC",
              fontWeight: 400,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#ffffff",
              },
            },
          },
        ],
        series: datas,
      };
      //   this.charts.carQsChart.setOption(this.options.carQsChartOption)
      this.personCountChart.setOption(this.personCountChartOption);
    },
  },
};
</script>
<style lang='scss' scoped>
.people-count {
  height: 100%;
}
</style>
